import UploadDataBtn from '@Resources/assets/icons/dark/cloud2.svg';
import Flex from '@Styles/flex.scss';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import { Divider, Menu, MenuItem, Skeleton, SvgIcon } from '@mui/material';
import cx from 'classnames';
import _isNil from 'lodash/isNil';
import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CloseableDrawer } from '@Components/Drawers/CloseableDrawer/CloseableDrawer';
import CloseableDrawerStyles from '@Components/Drawers/CloseableDrawer/CloseableDrawer.scss';
import { IconButton } from '@Components/IconButton';
import Page from '@Components/Page/Page';
import FoldersApi from '@Data/folders/Api';
import { IFolder } from '@Data/folders/Interfaces';
import { ProjectActionType } from '@Data/projects/ProjectActionTypes';
import Styles from './InProgressView.scss';
import { EntitiesList } from './components/InProgress/EntitiesTable/EntitiesList';
import { EntityDetails } from './components/InProgress/EntityDetails/EntityDetails';
import { EntityImagesCycle } from './components/InProgress/EntityImages/EntityImagesCycle';
import { QualityControlMapAndStreetView } from './components/InProgress/Map/MapAndStreetView';
import { PlanView } from './components/InProgress/PlanView/PlanView';
import { QualityControlBlock } from './components/InProgress/QcBlock/QualityControlBlock';
import SVGPoleViewer from './components/InProgress/SvgViewer/SVGPoleViewer';
import { ImageCarouselController } from './components/InProgress/SvgViewer/components/ImageCarouselController';

export const InProgressView = (props) => {
    const { isLoading, selectedProject, onManageProject, selectedTeam } = props;
    const drawerRef = useRef<CloseableDrawer>(null);
    const [isSettingsDialogOpen, setIsSettingsDialogOpen] =
        useState<boolean>(false);
    const { projectId } = useParams();
    const [isManageDialogueOpen, setIsManageDialogueOpen] =
        useState<boolean>(false);
    const [selectedFolder, setSelectedFolder] = useState<IFolder>(null);
    const [dataMenuIsOpen, setDataMenIsOpen] = useState<boolean>(false);
    const uploadDataBtnId = 'upload-data-btn';
    const projectSettingsBtnId = 'project-settings-btn';

    const [isDownloadFilesOpen, setIsDownloadFilesOpen] =
        useState<boolean>(false);
    const [openDialogueType, setOpenDialogueType] =
        useState<ProjectActionType | null>(null);
    const handleOpenProjectSettingsDialog = () => {
        drawerRef.current.closeDrawer();
        setIsSettingsDialogOpen(true);
    };

    const handleUpdateJobSettings = async () => {
        await FoldersApi.getFolders(parseInt(projectId));
        setIsSettingsDialogOpen(false);
    };

    const handleClearVisibleFolders = () => {
        FoldersApi.clearVisibleFolders();
    };

    const handleCreateFolderBtnClick = () => {
        setSelectedFolder(null);
        setIsManageDialogueOpen(true);
    };

    const handleFileUploadBtnClick = () => {
        setOpenDialogueType(ProjectActionType.UPLOAD_FILE);
    };

    const toggleDataMenu = () => {
        setDataMenIsOpen(!dataMenuIsOpen);
    };

    const handleConnectDeptClick = () => {
        setOpenDialogueType(ProjectActionType.CONNECT_DEPT);
    };

    const uploadData = (
        <IconButton
            onClick={toggleDataMenu}
            id={uploadDataBtnId}
            tooltip="Add Data"
            icon={
                <SvgIcon inheritViewBox>
                    <UploadDataBtn />
                </SvgIcon>
            }
            key={'uploadDataIconButton'}
        />
    );

    const uploadDataMenu = (
        <Menu
            id="upload-data-menu"
            open={dataMenuIsOpen}
            onClose={toggleDataMenu}
            anchorEl={document.getElementById(uploadDataBtnId)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            keepMounted
            key={'uploadDataMenu'}
        >
            <MenuItem
                id="upload-data-option"
                onClick={() => {
                    handleFileUploadBtnClick();
                    toggleDataMenu();
                }}
                dense
            >
                Upload Data
            </MenuItem>
            <Divider />
            <MenuItem
                id="connect-dept-option"
                onClick={() => {
                    handleConnectDeptClick();
                    toggleDataMenu();
                }}
                disabled={isLoading || !_isNil(selectedProject?.department_id)}
                dense
            >
                Connect IKE Office Department
            </MenuItem>
        </Menu>
    );

    const projectSettingsIcon = (
        <IconButton
            onClick={handleOpenProjectSettingsDialog}
            id={projectSettingsBtnId}
            tooltip={'Project Settings'}
            icon={
                <SvgIcon inheritViewBox>
                    <SettingsApplicationsOutlinedIcon
                        fontSize="small"
                        color="gradientGrey"
                    />
                </SvgIcon>
            }
            key={'projectSettingsIconButton'}
        />
    );

    const iconBtns = isLoading ? (
        <Skeleton
            animation="wave"
            width={100}
            height={28}
            style={{ marginLeft: '8px' }}
        />
    ) : (
        [uploadData, uploadDataMenu, projectSettingsIcon]
    );

    return (
        <>
            <Page>
                <div className={Styles.mainContainer}>
                    <div className={Styles.svgContainer}>
                        <SVGPoleViewer />
                        <ImageCarouselController />
                    </div>
                    <div
                        className={Styles.lowerPanelsContainer}
                        id="lowerPanelsContainer"
                    >
                        <QualityControlMapAndStreetView />
                        <EntityDetails />
                        <PlanView />
                        <EntityImagesCycle />
                        <QualityControlBlock />{' '}
                    </div>
                </div>
            </Page>
            <CloseableDrawer ref={drawerRef}>
                <div className={CloseableDrawerStyles.drawerHeadersContainer}>
                    <div className={cx(Flex.flex, Flex.justifyBetween)}>
                        <span id="closable-drawer-folder-name">
                            {selectedFolder?.folder_name}
                        </span>

                        <div style={{ display: 'flex', marginRight: '12px' }}>
                            {iconBtns}
                        </div>
                    </div>
                </div>
                <EntitiesList />
            </CloseableDrawer>
        </>
    );
};
